import { render } from "./FormAlertComponent.vue?vue&type=template&id=179332a6&scoped=true"
import script from "./FormAlertComponent.vue?vue&type=script&lang=js"
export * from "./FormAlertComponent.vue?vue&type=script&lang=js"

import "./FormAlertComponent.vue?vue&type=style&index=0&id=179332a6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179332a6"]])

export default __exports__